"use strict";
// Generated by Peggy 2.0.1.
//
// https://peggyjs.org/
Object.defineProperty(exports, "__esModule", { value: true });
const parser = (function () {
    "use strict";
    function peg$subclass(child, parent) {
        function C() { this.constructor = child; }
        C.prototype = parent.prototype;
        child.prototype = new C();
    }
    function peg$SyntaxError(message, expected, found, location) {
        var self = Error.call(this, message);
        // istanbul ignore next Check is a necessary evil to support older environments
        if (Object.setPrototypeOf) {
            Object.setPrototypeOf(self, peg$SyntaxError.prototype);
        }
        self.expected = expected;
        self.found = found;
        self.location = location;
        self.name = "SyntaxError";
        return self;
    }
    peg$subclass(peg$SyntaxError, Error);
    function peg$padEnd(str, targetLength, padString) {
        padString = padString || " ";
        if (str.length > targetLength) {
            return str;
        }
        targetLength -= str.length;
        padString += padString.repeat(targetLength);
        return str + padString.slice(0, targetLength);
    }
    peg$SyntaxError.prototype.format = function (sources) {
        var str = "Error: " + this.message;
        if (this.location) {
            var src = null;
            var k;
            for (k = 0; k < sources.length; k++) {
                if (sources[k].source === this.location.source) {
                    src = sources[k].text.split(/\r\n|\n|\r/g);
                    break;
                }
            }
            var s = this.location.start;
            var loc = this.location.source + ":" + s.line + ":" + s.column;
            if (src) {
                var e = this.location.end;
                var filler = peg$padEnd("", s.line.toString().length, ' ');
                var line = src[s.line - 1];
                var last = s.line === e.line ? e.column : line.length + 1;
                var hatLen = (last - s.column) || 1;
                str += "\n --> " + loc + "\n"
                    + filler + " |\n"
                    + s.line + " | " + line + "\n"
                    + filler + " | " + peg$padEnd("", s.column - 1, ' ')
                    + peg$padEnd("", hatLen, "^");
            }
            else {
                str += "\n at " + loc;
            }
        }
        return str;
    };
    peg$SyntaxError.buildMessage = function (expected, found) {
        var DESCRIBE_EXPECTATION_FNS = {
            literal: function (expectation) {
                return "\"" + literalEscape(expectation.text) + "\"";
            },
            class: function (expectation) {
                var escapedParts = expectation.parts.map(function (part) {
                    return Array.isArray(part)
                        ? classEscape(part[0]) + "-" + classEscape(part[1])
                        : classEscape(part);
                });
                return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]";
            },
            any: function () {
                return "any character";
            },
            end: function () {
                return "end of input";
            },
            other: function (expectation) {
                return expectation.description;
            }
        };
        function hex(ch) {
            return ch.charCodeAt(0).toString(16).toUpperCase();
        }
        function literalEscape(s) {
            return s
                .replace(/\\/g, "\\\\")
                .replace(/"/g, "\\\"")
                .replace(/\0/g, "\\0")
                .replace(/\t/g, "\\t")
                .replace(/\n/g, "\\n")
                .replace(/\r/g, "\\r")
                .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
        }
        function classEscape(s) {
            return s
                .replace(/\\/g, "\\\\")
                .replace(/\]/g, "\\]")
                .replace(/\^/g, "\\^")
                .replace(/-/g, "\\-")
                .replace(/\0/g, "\\0")
                .replace(/\t/g, "\\t")
                .replace(/\n/g, "\\n")
                .replace(/\r/g, "\\r")
                .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
        }
        function describeExpectation(expectation) {
            return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }
        function describeExpected(expected) {
            var descriptions = expected.map(describeExpectation);
            var i, j;
            descriptions.sort();
            if (descriptions.length > 0) {
                for (i = 1, j = 1; i < descriptions.length; i++) {
                    if (descriptions[i - 1] !== descriptions[i]) {
                        descriptions[j] = descriptions[i];
                        j++;
                    }
                }
                descriptions.length = j;
            }
            switch (descriptions.length) {
                case 1:
                    return descriptions[0];
                case 2:
                    return descriptions[0] + " or " + descriptions[1];
                default:
                    return descriptions.slice(0, -1).join(", ")
                        + ", or "
                        + descriptions[descriptions.length - 1];
            }
        }
        function describeFound(found) {
            return found ? "\"" + literalEscape(found) + "\"" : "end of input";
        }
        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
    };
    function peg$parse(input, options) {
        options = options !== undefined ? options : {};
        var peg$FAILED = {};
        var peg$source = options.grammarSource;
        var peg$startRuleFunctions = { Start: peg$parseStart };
        var peg$startRuleFunction = peg$parseStart;
        var peg$c0 = "(";
        var peg$c1 = ")";
        var peg$c2 = "$";
        var peg$c3 = "[";
        var peg$c4 = "]";
        var peg$r0 = /^[ a-zA-Z0-9,.\-_#+*'`\xB4?!=\xA0\/&%\xA7\xF6\xD6\xE4\xC4\u20AC%&"\^\u2013<>\\]/;
        var peg$r1 = /^[ \t\s\n]/;
        var peg$r2 = /^[0-9]/;
        var peg$e0 = peg$otherExpectation("Cross / Distinction");
        var peg$e1 = peg$otherExpectation("Left bracket");
        var peg$e2 = peg$literalExpectation("(", false);
        var peg$e3 = peg$otherExpectation("Right bracket");
        var peg$e4 = peg$literalExpectation(")", false);
        var peg$e5 = peg$otherExpectation("Value of a space");
        var peg$e6 = peg$classExpectation([" ", ["a", "z"], ["A", "Z"], ["0", "9"], ",", ".", "-", "_", "#", "+", "*", "'", "`", "\xB4", "?", "!", "=", "\xA0", "/", "&", "%", "\xA7", "\xF6", "\xD6", "\xE4", "\xC4", "\u20AC", "%", "&", "\"", "^", "\u2013", "<", ">", "\\"], false, false);
        var peg$e7 = peg$otherExpectation("Space Id");
        var peg$e8 = peg$literalExpectation("$", false);
        var peg$e9 = peg$otherExpectation("whitespace");
        var peg$e10 = peg$classExpectation([" ", "\t", "\s", "\n"], false, false);
        var peg$e11 = peg$otherExpectation("Number");
        var peg$e12 = peg$classExpectation([["0", "9"]], false, false);
        var peg$e13 = peg$otherExpectation("Expression type -> Value, Cross(), ReEntry Space Id, Space Id");
        var peg$e14 = peg$otherExpectation("ReEntry Space Id");
        var peg$e15 = peg$literalExpectation("[", false);
        var peg$e16 = peg$literalExpectation("]", false);
        var peg$e17 = peg$otherExpectation("Expression");
        var peg$f0 = function (expr) { return expr[0]; };
        var peg$f1 = function (expr) { return expr; };
        var peg$f2 = function () { depth += 1; };
        var peg$f3 = function () { depth -= 1; };
        var peg$f4 = function () { return text().trim(); };
        var peg$f5 = function (id) { return id; };
        var peg$f6 = function () { return parseInt(text()); };
        var peg$f7 = function (r) { return [null, [r], null, depth + 1]; };
        var peg$f8 = function (v) { return [v, [], null, depth]; };
        var peg$f9 = function (d) { return [null, [d[0]], null, d[1]]; };
        var peg$f10 = function (i) { return [null, [], i, depth + 1]; };
        var peg$f11 = function (id) { return id; };
        var peg$f12 = function (subExpr) {
            id += 1;
            return [{
                    data: subExpr.map(expr => expr[0]).join(' ').trim(),
                    id: subExpr.reduce((acc, expr) => expr[2] !== null ? expr[2] : acc, "_" + id),
                    depth: depth,
                    maxDepth: Math.max(...subExpr.map(s => s[3])) - depth,
                    expressions: subExpr.reduce((acc, expr) => [...acc, ...expr[1]], []),
                }, Math.max(...subExpr.map(s => s[3]))];
        };
        var peg$currPos = 0;
        var peg$savedPos = 0;
        var peg$posDetailsCache = [{ line: 1, column: 1 }];
        var peg$maxFailPos = 0;
        var peg$maxFailExpected = [];
        var peg$silentFails = 0;
        var peg$result;
        if ("startRule" in options) {
            if (!(options.startRule in peg$startRuleFunctions)) {
                throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
            }
            peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
        }
        function text() {
            return input.substring(peg$savedPos, peg$currPos);
        }
        function offset() {
            return peg$savedPos;
        }
        function range() {
            return {
                source: peg$source,
                start: peg$savedPos,
                end: peg$currPos
            };
        }
        function location() {
            return peg$computeLocation(peg$savedPos, peg$currPos);
        }
        function expected(description, location) {
            location = location !== undefined
                ? location
                : peg$computeLocation(peg$savedPos, peg$currPos);
            throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
        }
        function error(message, location) {
            location = location !== undefined
                ? location
                : peg$computeLocation(peg$savedPos, peg$currPos);
            throw peg$buildSimpleError(message, location);
        }
        function peg$literalExpectation(text, ignoreCase) {
            return { type: "literal", text: text, ignoreCase: ignoreCase };
        }
        function peg$classExpectation(parts, inverted, ignoreCase) {
            return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
        }
        function peg$anyExpectation() {
            return { type: "any" };
        }
        function peg$endExpectation() {
            return { type: "end" };
        }
        function peg$otherExpectation(description) {
            return { type: "other", description: description };
        }
        function peg$computePosDetails(pos) {
            var details = peg$posDetailsCache[pos];
            var p;
            if (details) {
                return details;
            }
            else {
                p = pos - 1;
                while (!peg$posDetailsCache[p]) {
                    p--;
                }
                details = peg$posDetailsCache[p];
                details = {
                    line: details.line,
                    column: details.column
                };
                while (p < pos) {
                    if (input.charCodeAt(p) === 10) {
                        details.line++;
                        details.column = 1;
                    }
                    else {
                        details.column++;
                    }
                    p++;
                }
                peg$posDetailsCache[pos] = details;
                return details;
            }
        }
        function peg$computeLocation(startPos, endPos) {
            var startPosDetails = peg$computePosDetails(startPos);
            var endPosDetails = peg$computePosDetails(endPos);
            return {
                source: peg$source,
                start: {
                    offset: startPos,
                    line: startPosDetails.line,
                    column: startPosDetails.column
                },
                end: {
                    offset: endPos,
                    line: endPosDetails.line,
                    column: endPosDetails.column
                }
            };
        }
        function peg$fail(expected) {
            if (peg$currPos < peg$maxFailPos) {
                return;
            }
            if (peg$currPos > peg$maxFailPos) {
                peg$maxFailPos = peg$currPos;
                peg$maxFailExpected = [];
            }
            peg$maxFailExpected.push(expected);
        }
        function peg$buildSimpleError(message, location) {
            return new peg$SyntaxError(message, null, null, location);
        }
        function peg$buildStructuredError(expected, found, location) {
            return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
        }
        function peg$parseStart() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parse_();
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parse_();
            }
            s2 = peg$parseExpression();
            peg$savedPos = s0;
            s0 = peg$f0(s2);
            return s0;
        }
        function peg$parseDistinction() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            peg$silentFails++;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parse_();
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parse_();
            }
            s2 = peg$parseleftBracket();
            if (s2 !== peg$FAILED) {
                s3 = [];
                s4 = peg$parse_();
                while (s4 !== peg$FAILED) {
                    s3.push(s4);
                    s4 = peg$parse_();
                }
                s4 = peg$parseExpression();
                if (s4 !== peg$FAILED) {
                    s5 = [];
                    s6 = peg$parse_();
                    while (s6 !== peg$FAILED) {
                        s5.push(s6);
                        s6 = peg$parse_();
                    }
                    s6 = peg$parserightBracket();
                    if (s6 !== peg$FAILED) {
                        s7 = [];
                        s8 = peg$parse_();
                        while (s8 !== peg$FAILED) {
                            s7.push(s8);
                            s8 = peg$parse_();
                        }
                        peg$savedPos = s0;
                        s0 = peg$f1(s4);
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e0);
                }
            }
            return s0;
        }
        function peg$parseleftBracket() {
            var s0, s1;
            peg$silentFails++;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 40) {
                s1 = peg$c0;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e2);
                }
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f2();
            }
            s0 = s1;
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e1);
                }
            }
            return s0;
        }
        function peg$parserightBracket() {
            var s0, s1;
            peg$silentFails++;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 41) {
                s1 = peg$c1;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e4);
                }
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f3();
            }
            s0 = s1;
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e3);
                }
            }
            return s0;
        }
        function peg$parseValue() {
            var s0, s1, s2;
            peg$silentFails++;
            s0 = peg$currPos;
            s1 = [];
            if (peg$r0.test(input.charAt(peg$currPos))) {
                s2 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e6);
                }
            }
            if (s2 !== peg$FAILED) {
                while (s2 !== peg$FAILED) {
                    s1.push(s2);
                    if (peg$r0.test(input.charAt(peg$currPos))) {
                        s2 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e6);
                        }
                    }
                }
            }
            else {
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f4();
            }
            s0 = s1;
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e5);
                }
            }
            return s0;
        }
        function peg$parseId() {
            var s0, s1, s2;
            peg$silentFails++;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 36) {
                s1 = peg$c2;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e8);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseNumber();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f5(s2);
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e7);
                }
            }
            return s0;
        }
        function peg$parse_() {
            var s0, s1;
            peg$silentFails++;
            if (peg$r1.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e10);
                }
            }
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e9);
                }
            }
            return s0;
        }
        function peg$parseNumber() {
            var s0, s1, s2;
            peg$silentFails++;
            s0 = peg$currPos;
            s1 = [];
            if (peg$r2.test(input.charAt(peg$currPos))) {
                s2 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e12);
                }
            }
            if (s2 !== peg$FAILED) {
                while (s2 !== peg$FAILED) {
                    s1.push(s2);
                    if (peg$r2.test(input.charAt(peg$currPos))) {
                        s2 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e12);
                        }
                    }
                }
            }
            else {
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f6();
            }
            s0 = s1;
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e11);
                }
            }
            return s0;
        }
        function peg$parseSubExpression() {
            var s0, s1;
            peg$silentFails++;
            s0 = peg$currPos;
            s1 = peg$parseReEntry();
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f7(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseValue();
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$f8(s1);
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$parseDistinction();
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$f9(s1);
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        s1 = peg$parseId();
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$f10(s1);
                        }
                        s0 = s1;
                    }
                }
            }
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e13);
                }
            }
            return s0;
        }
        function peg$parseReEntry() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            peg$silentFails++;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parse_();
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parse_();
            }
            if (input.charCodeAt(peg$currPos) === 91) {
                s2 = peg$c3;
                peg$currPos++;
            }
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e15);
                }
            }
            if (s2 !== peg$FAILED) {
                s3 = [];
                s4 = peg$parse_();
                while (s4 !== peg$FAILED) {
                    s3.push(s4);
                    s4 = peg$parse_();
                }
                s4 = peg$parseNumber();
                if (s4 !== peg$FAILED) {
                    s5 = [];
                    s6 = peg$parse_();
                    while (s6 !== peg$FAILED) {
                        s5.push(s6);
                        s6 = peg$parse_();
                    }
                    if (input.charCodeAt(peg$currPos) === 93) {
                        s6 = peg$c4;
                        peg$currPos++;
                    }
                    else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e16);
                        }
                    }
                    if (s6 !== peg$FAILED) {
                        s7 = [];
                        s8 = peg$parse_();
                        while (s8 !== peg$FAILED) {
                            s7.push(s8);
                            s8 = peg$parse_();
                        }
                        peg$savedPos = s0;
                        s0 = peg$f11(s4);
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e14);
                }
            }
            return s0;
        }
        function peg$parseExpression() {
            var s0, s1, s2;
            peg$silentFails++;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseSubExpression();
            while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parseSubExpression();
            }
            peg$savedPos = s0;
            s1 = peg$f12(s1);
            s0 = s1;
            peg$silentFails--;
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e17);
            }
            return s0;
        }
        let id = 0;
        let depth = 0;
        peg$result = peg$startRuleFunction();
        if (peg$result !== peg$FAILED && peg$currPos === input.length) {
            return peg$result;
        }
        else {
            if (peg$result !== peg$FAILED && peg$currPos < input.length) {
                peg$fail(peg$endExpectation());
            }
            throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length
                ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
                : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
        }
    }
    return {
        SyntaxError: peg$SyntaxError,
        parse: peg$parse
    };
})();
exports.default = parser;
